import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute } from '@angular/router';

import { AdminComponentBase } from 'app/layout/content/admin-component-base';
import { PageSimpleContentComponent } from 'app/layout/content/page-simple-content.component';
import { AuthorizationContext, AuthorizationService } from 'app/shared/authentication';
import { ErrorComponent } from 'app/shared/components/error.component';
import { SaveButtonComponent } from 'app/shared/components/save-button.component';
import { SecretInputToggleComponent } from 'app/shared/components/secret-input-toggle.component';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog.component';
import { GeneratedTextConfiguration } from 'app/shared/graph';

import { StoreGeneratedTextService } from "./store-generated-text.service";

@Component({
    selector: 'admin-store-generated-text',
    templateUrl: './store-generated-text-page.component.html',
    styleUrls: ['./store-generated-text-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, MatButton, MatIcon, FormsModule, MatFormField, MatLabel, MatInput, SecretInputToggleComponent, MatSuffix, SaveButtonComponent, ErrorComponent]
})
export class StoreGeneratedTextPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);
    private readonly authService = inject(AuthorizationService);
    private readonly storeGeneratedTextService = inject(StoreGeneratedTextService);
    private readonly matDialog = inject(MatDialog);

    private readonly defaultConfig : GeneratedTextConfiguration = {
        accessToken: '',
        organization: '',
    };
    private storeId: string;
    private authContext?: AuthorizationContext;

    public hasConfigDefined: boolean;
    public currentGeneratedTextConfig: GeneratedTextConfiguration = this.defaultConfig;

    ngOnInit(): void {
        this.authService.authorizationContext().subscribe(authContext => this.authContext = authContext);
        this.registerSubscription(this.route.params.subscribe(async params => {
            this.storeId = params.storeId;
            this.subscribeWithGenericLoadingErrorHandling(this.storeGeneratedTextService.getConfig(this.storeId), (generatedTextConfig) => {
                this.hasConfigDefined = !!generatedTextConfig;
                if (generatedTextConfig)
                    this.currentGeneratedTextConfig = generatedTextConfig;
            });
        }))
    }

    ngOnDestroy(): void {
        this.unsubscribeSubscriptions();
    }

    deleteConfig() {
        const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Delete configuration',
                message: `Do you really want to delete that configuration ?`,
                options: {
                    yes: {
                        label: 'Delete',
                        warn: true
                    },
                    no: {
                        label: 'Cancel'
                    }
                }
            }
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (!result) {
                return;
            }
            this.subscribeWithGenericSavingErrorHandling(this.storeGeneratedTextService.deleteConfiguration({ storeId: this.storeId }), () => {
                this.hasConfigDefined = false;
                this.currentGeneratedTextConfig = this.defaultConfig;
            });
        });
    }

    save() {
        this.subscribeWithGenericSavingErrorHandling(this.storeGeneratedTextService.updateConfiguration({
            ...this.currentGeneratedTextConfig,
            storeId: this.storeId
        }), () => {
            this.hasConfigDefined = true;
        });
    }
}
